module.exports = __webpack_public_path__ + "static/media/ic_tria.669a0de5.svg";